"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _intl = require("@kyruus/intl");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const proptypes = {
  /** The config object for the customer */
  config: _propTypes.object.isRequired,
  /** The state machine of the current page  */
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  /** Tracking function */
  track: _propTypes.func.isRequired
};
const MobileAltProvidersComponent = _ref => {
  let {
    config,
    service,
    track
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    altProviders,
    services
  } = state.context;
  const detailedAltProviders = (0, _react.useMemo)(() => {
    if (!altProviders) {
      return [];
    }
    return (0, _map.default)(altProviders).call(altProviders, providerResult => {
      return {
        availability: providerResult.availability,
        config,
        location: providerResult.locations[0],
        provider: providerResult.provider
      };
    });
  }, [altProviders, config]);
  if (detailedAltProviders.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_styles.MobileAltProvidersContainer, {
    "data-testid": "dbw-mobile-alt-providers"
  }, /*#__PURE__*/_react.default.createElement(_styles.MobileAltProvidersHeader, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.altProvidersHeader)), /*#__PURE__*/_react.default.createElement(_styles.MobileAltProviders, {
    createAvailabilityUrl: services.createAvailabilityUrl,
    createProviderUrl: services.createProviderUrl,
    providers: detailedAltProviders,
    track: track
  }));
};
MobileAltProvidersComponent.propTypes = proptypes;
var _default = exports.default = MobileAltProvidersComponent;
MobileAltProvidersComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileAltProvidersComponent",
  "props": {
    "config": {
      "description": "The config object for the customer",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "service": {
      "description": "The state machine of the current page",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "Tracking function",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};